import React, { useContext } from "react";
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  Popover,
  Typography,
  ListItemIcon,
} from "@mui/material";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import logo from "../logo/logo.svg";
import NewLogo from '../logo/NewLogo.png';
import new1 from '../logo/cluBits.svg';
import { useResponsive } from "../helper/use-reponsive";
import { useMinimized } from "../helper/context/sideMenuContext/menuContext";
import { primary } from "../pages/personalization/palette";
import useMenuList from "../helper/menuList";
import { AuthContext } from "../helper/context/auth/authContext";
import toast from "react-hot-toast";
import { getUserPermissions, getValidLogo } from '../helper/function-helper';

const SideMenu = () => {
  const theme = useTheme();
  const upLg = useResponsive("up", "lg");
  const { user } = useContext(AuthContext);
  const textLogo = getValidLogo(user?.[0]?.TextLogo, new1);
  const companyLogo = getValidLogo(user?.[0]?.CompanyLogo, logo);
const { isMinimized, setIsMinimized, isDrawerOpen, setDrawerOpen, anchorEl, setAnchorEl, openSubMenu, setOpenSubMenu,
    nestedAnchorEl,
    setNestedAnchorEl,
    nestedOpenSubMenu,
    setNestedOpenSubMenu
  } = useMinimized();
  const navigate = useNavigate();
  const menuList = useMenuList(user);
  const getUserPrevillage = getUserPermissions();

  const handleMenuClick = (event, label, item) => {
    // if (user[0]?.Role === 4 && item?.role !== 4) {
    //   return toast.error("Subscription Required");
    // }
    if (openSubMenu === label) {
      setOpenSubMenu(null);
      setAnchorEl(null);
      setNestedOpenSubMenu(null);
      setNestedAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
      setOpenSubMenu(label);
      setNestedOpenSubMenu(null);
      setNestedAnchorEl(null);
    }
  };

  const handleNestedMenuClick = (event, label, item) => {
    //     if (user[0]?.Role === 4 && item?.role !== 4) {
    //   return toast.error("Subscription Required");
    // }
    if (nestedOpenSubMenu === label) {
      setNestedOpenSubMenu(null);
      setNestedAnchorEl(null);
    } else {
      setNestedAnchorEl(event.currentTarget);
      setNestedOpenSubMenu(label);

    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenSubMenu(null);
    setNestedOpenSubMenu(null);
    setNestedAnchorEl(null);
  };

  const handleNavigation = (path, item) => {
    // if (user[0]?.Role === 4 && item?.role !== 4) {
    //   return toast.error("Subscription Required");
    // }
    if (path) {
      navigate(path);
      if (!upLg) setDrawerOpen(false);
      handleClose();
    }
  };

  const renderSubMenu = (subMenu) => (
    <List component="div" disablePadding>
      {subMenu?.map((subItem, index) => (
        <React.Fragment key={index}>
          {subItem.subMenu ? (<>
            <ListItem
              button
              onClick={(e) => handleNestedMenuClick(e, subItem?.label, subItem)}
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                height: 48,
                px: 2,
                cursor: "pointer",
                color: primary.dark,
                "&:hover": {
                  backgroundColor: primary.lighter,
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  borderRadius: "6px",
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 36, color: 'inherit' }}>
                {subItem.icon}
              </ListItemIcon>
              <ListItemText
                primary={subItem.label}
                primaryTypographyProps={{
                  style: {
                    fontSize: "0.875rem",
                    fontWeight: "500",
                  },
                }}
              />
              <ExpandMoreIcon fontSize="small" />
            </ListItem>
            <Popover
              open={nestedOpenSubMenu === subItem.label}
              anchorEl={nestedAnchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              PaperProps={{
                sx: {
                  ml: 2,
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.25)',
                  minWidth: 200,
                  py: 1,
                }
              }}
              sx={{
                zIndex: 1200
              }}
            >
              {renderSubMenu(subItem.subMenu)}
            </Popover>
          </>
          ) : (
            <ListItem
              button
              onClick={() => handleNavigation(subItem.path, subItem)}
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                height: 48,
                px: 2,
                cursor: "pointer",
                color: primary.dark,
                "&:hover": {
                  backgroundColor: primary.lighter,
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  borderRadius: "6px",
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 36, color: 'inherit' }}>
                {subItem.icon}
              </ListItemIcon>
              <ListItemText
                primary={subItem.label}
                primaryTypographyProps={{
                  style: {
                    fontSize: "0.875rem",
                    fontWeight: "500",
                  },
                }}
              />
            </ListItem>
          )}
        </React.Fragment>
      ))}
    </List>
  );

  return (
    <Box>
      <Drawer
        variant={upLg ? "permanent" : "temporary"}
        open={isDrawerOpen}
        onClose={() => setDrawerOpen(false)}
        sx={{
          width: isMinimized ? 60 : 220,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            zIndex: 10,
            width: isMinimized ? 60 : 220,
            boxSizing: "border-box",
            transition: "width 0.3s ease",
            color: primary.contrastText,
            borderRight: `1px solid ${theme.palette.divider}`,
            fontFamily: "'Poppins', sans-serif",
            display: 'flex',
            flexDirection: 'column',
            overflowX: 'hidden',
          },
        }}
      >
        <Box
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 64,
            background: "#ffff",
            margin: "8px",
            borderRadius: "8px",
            transition: 'all 0.3s ease',
          }}
        >
          <img
            style={{
              height: isMinimized ? 32 : 40,
              objectFit: "contain",
              transition: "all 0.3s ease",
            }}
            src={companyLogo}
            alt="NewLogo"
          />

          {!isMinimized && (
            // <Typography
            //   variant="h6"
            //   sx={{
            //     flexGrow: 1,
            //     fontWeight: 600,
            //     fontSize: "1.25rem",
            //     letterSpacing: "0.5px",
            //     ml: 2,
            //     color: "#000",
            //     whiteSpace: 'nowrap',
            //     overflow: 'hidden',
            //     textOverflow: 'ellipsis',
            //   }}
            // >
            //   ALLIAD
            // </Typography>
            <img
              style={{
                // height: isMinimized ? 32 : 40,
                objectFit: "cover",
                transition: "all 0.3s ease",
                width:'100%',
                height:'100%',
                objectPosition: 'center',
                paddingLeft:10
              }}
              src={textLogo}
              alt="new1"
            />
          )}
        </Box>
        <Box sx={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', px: 1 }}>
          <List sx={{ py: 0 }}>
            <Tooltip
              title={isMinimized ? (isMinimized ? "Maximize" : "Minimize") : ""}
              placement="right"
              disableHoverListener={!isMinimized}
            >
              <ListItem
                button
                onClick={() => { setIsMinimized(!isMinimized); handleClose() }}
                sx={{
                  display: "flex",
                  flexDirection: isMinimized ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "center",
                  height: 48,
                  px: isMinimized ? 0 : 2,
                  my: 0.5,
                  cursor: "pointer",
                  color: primary.main,
                  zIndex: 10000,
                  "&:hover": {
                    zIndex: 10000,
                    backgroundColor: primary.lighter,
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    borderRadius: "6px",
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 'auto',
                    color: 'inherit',
                    mr: isMinimized ? 0 : 1.5,
                  }}
                >
                  {isMinimized ? <FullscreenIcon fontSize="small" /> : <FullscreenExitIcon fontSize="small" />}
                </ListItemIcon>
                {!isMinimized && (
                  <ListItemText
                    primary={isMinimized ? "Maximize" : "Minimize"}
                    primaryTypographyProps={{
                      style: {
                        fontSize: "0.875rem",
                        fontWeight: 500,
                      },
                    }}
                  />
                )}
              </ListItem>
            </Tooltip>

            {menuList?.map((item, index) => (
              <React.Fragment key={index}>
                {item.subMenu ? (
                  <>
                    <Tooltip
                      title={isMinimized ? item.label : ""}
                      placement="right"
                      disableHoverListener={!isMinimized}
                    >
                      <ListItem
                        button
                        onClick={(e) => handleMenuClick(e, item.label, item)}
                        sx={{
                          display: "flex",
                          flexDirection: isMinimized ? "column" : "row",
                          alignItems: "center",
                          justifyContent: isMinimized ? "center" : "space-between",
                          height: 48,
                          px: isMinimized ? 0 : 2,
                          my: 0.5,
                          cursor: "pointer",
                          color: primary.main,
                          zIndex: 10000,
                          "&:hover": {
                            zIndex: 10000,
                            backgroundColor: primary.lighter,
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                            borderRadius: "6px",
                          },
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 'auto',
                            color: 'inherit',
                            mr: isMinimized ? 0 : 1.5,
                          }}
                        >
                          {item.icon}
                        </ListItemIcon>
                        {!isMinimized && (
                          <>
                            <ListItemText
                              primary={item.label}
                              primaryTypographyProps={{
                                style: {
                                  fontSize: "0.875rem",
                                  fontWeight: 500,
                                },
                              }}
                            />
                            {openSubMenu === item.label ?
                              <ExpandLessIcon fontSize="small" /> :
                              <ExpandMoreIcon fontSize="small" />
                            }
                          </>
                        )}
                      </ListItem>
                    </Tooltip>
                    <Popover
                      open={openSubMenu === item.label}
                      anchorEl={anchorEl}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      PaperProps={{
                        sx: {
                          ml: 2,
                          borderRadius: '8px',
                          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.25)',
                          minWidth: 200,
                          py: 1,
                        }
                      }}
                      sx={{
                        zIndex: 1200
                      }}
                    >
                      {renderSubMenu(item.subMenu)}
                    </Popover>
                  </>
                ) : (
                  <Tooltip
                    title={isMinimized ? item.label : ""}
                    placement="right"
                    disableHoverListener={!isMinimized}
                  >
                    <ListItem
                      button
                      onClick={() => handleNavigation(item.path, item)}
                      sx={{
                        display: "flex",
                        flexDirection: isMinimized ? "column" : "row",
                        alignItems: "center",
                        justifyContent: "center",
                        height: 48,
                        px: isMinimized ? 0 : 2,
                        my: 0.5,
                        cursor: "pointer",
                        color: primary.main,
                        "&:hover": {
                          backgroundColor: primary.lighter,
                          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                          borderRadius: "6px",
                        },
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 'auto',
                          color: 'inherit',
                          mr: isMinimized ? 0 : 1.5,
                        }}
                      >
                        {item.icon}
                      </ListItemIcon>
                      {!isMinimized && (
                        <ListItemText
                          primary={item.label === 'HRMS Dashboard' ? 'Dashboard' : item.label}
                          primaryTypographyProps={{
                            style: {
                              fontSize: "0.875rem",
                              fontWeight: 500,
                            },
                          }}
                        />
                      )}
                    </ListItem>
                  </Tooltip>
                )}
              </React.Fragment>
            ))}
          </List>
        </Box>
      </Drawer>
    </Box>
  );
};

export default SideMenu;